"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
var Algemeen = require("./Algemeen");
var enableLogging = true;
//if (!window.console) console = { log: function () { } };
function log(value) {
    //arguments.callee.caller.toString()
    if (enableLogging) {
        console.log(value);
    }
}
exports.log = log;
window.onerror = function (msg, url, line) {
    debugger;
    var ClientErrorMessage = "Error: " + msg + "\nurl: " + url + "\nline #: " + line;
    log(ClientErrorMessage);
    Algemeen.CallWebServiceGetGenericData('ProcessClientError', JSON.stringify({ ClientErrorMessage: ClientErrorMessage }), OnSuccessProcessClientError);
    return true;
};
function OnSuccessProcessClientError(data, status) {
    var Gelukt = data.d;
    if (!Gelukt) {
        log('WebService ProcessClientError failed');
    }
}
